var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-checkbox',{attrs:{"label-text":_vm.$t('langkey.sale_mode.function'),"reverse":""},on:{"input":_vm.onInputSelectFilter},model:{value:(_vm.isOptInValue),callback:function ($$v) {_vm.isOptInValue=$$v},expression:"isOptInValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }